import React from "react";
import "url-search-params-polyfill";
import kasp_logo from "../assets/img/kasp-logo.svg";
import internetforkids from "../assets/img/internetforkids.svg";

export default class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      email: "",
      emailError: false,
      emailErrorText: "",
      agree: false,
      agreeError: false,
      agreeErrorText: "",
      success: false,
    };
  }

  static defaultProps = {
    isFooterSubscribe: true,
  };

  subscribe = async () => {
    let errors = false;
    if (this.state.email === "") {
      this.setState({
        emailError: true,
        emailErrorText: "Необходимо заполнить Email",
      });
      errors = true;
    } else {
      let re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(this.state.email)) {
        errors = true;
        this.setState({
          emailError: true,
          emailErrorText: "Поле Email имеет неправильный формат",
        });
      }
    }

    if (this.state.agree === false) {
      this.setState({
        agreeError: true,
        agreeErrorText: "Необходимо ваше согласие",
      });
      errors = true;
    }

    if (errors === false) {
      this.setState({
        loading: true,
      });
      const formData = new FormData();
      formData.append("email", this.state.email);
      formData.append("subscription_agreement", 1);
      await fetch("/backend/api/subscribe", {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.error === 0) {
            this.setState(
              {
                success: true,
                loading: false,
                email: "",
                agree: false,
              },
              () => {
                setTimeout(() => {
                  this.setState({
                    success: false,
                  });
                }, 2000);
              }
            );
          } else {
            this.setState({
              emailError: true,
              emailErrorText: response.message.email,
              loading: false,
            });
          }
        });
    }
  };

  renderEmailError = () => {
    if (this.state.emailError) {
      return (
        <div
          onClick={() => {
            this.setState({ emailError: false });
          }}
          className="error__message"
        >
          {this.state.emailErrorText}
        </div>
      );
    }
  };

  renderAgreeError = () => {
    if (this.state.agreeError) {
      return (
        <div
          onClick={() => {
            this.setState({ agreeError: false });
          }}
          className="error__message"
        >
          {this.state.agreeErrorText}
        </div>
      );
    }
  };

  render() {
    return (
      <div className="footer">
        {this.props.isFooterSubscribe && (
          <div className="footer__top">
            <div className="container">
              <div className="row justify-content-end">
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                  <div className="subscribe__box">
                    <div className="subscribe__box-title">
                      Подпишитесь на ежемесячную подборку статей
                    </div>
                    <div
                      className={
                        "subscribe__form d-flex " +
                        (this.state.success ? "success-mode" : "")
                      }
                    >
                      <div
                        className={
                          "subscribe__field " +
                          (this.state.emailError ? "error" : "")
                        }
                      >
                        <input
                          onFocus={() => {
                            this.setState({ emailError: false });
                          }}
                          onChange={(email) => {
                            this.setState({ email: email.target.value });
                          }}
                          type="text"
                          value={this.state.email}
                          placeholder="E-mail"
                        />
                        {this.renderEmailError()}
                      </div>
                      <div
                        className={
                          "actions__wrap hidden-sm-down" +
                          (this.state.loading ? "disbaled" : "")
                        }
                      >
                        <div
                          onClick={() => {
                            this.subscribe();
                          }}
                          className="subscribe__btn d-flex align-items-center justify-content-center"
                        >
                          Подписаться
                        </div>
                      </div>
                      <div className="success">
                        Поздравляем! Вы успешно подписались!
                      </div>
                    </div>
                    <div
                      className={
                        "checkbox__wrap " +
                        (this.state.agreeError ? "error " : "") +
                        (this.state.success ? "success-mode" : "")
                      }
                    >
                      <label>
                        <input
                          onChange={(agree) => {
                            this.setState({
                              agree: agree.target.checked,
                            });
                            this.setState({ agreeError: false });
                          }}
                          type="checkbox"
                        />
                        <div className="checkbox__decor"></div>
                        <div className="checkbox__title">
                          Я подтверждаю, что разрешаю AO «Лаборатория
                          Касперского» использовать мой адрес электронной почты,
                          чтобы отправлять мне актуальные новости и статьи (в
                          любой момент вы можете отписаться от рассылки, перейдя
                          по специальной ссылке для отзыва согласия в связанных
                          письмах).
                        </div>
                      </label>
                      {this.renderAgreeError()}
                    </div>
                    <div
                      className={
                        "actions__wrap hidden-md-up" +
                        (this.state.loading ? "disbaled" : "")
                      }
                    >
                      <div
                        onClick={() => {
                          this.subscribe();
                        }}
                        className="subscribe__btn d-flex align-items-center justify-content-center"
                      >
                        Подписаться
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="footer__bottom">
          <div class="container internetforkids">
            <a href="https://internetforkids.ru/" target="_blank">
              <img src={internetforkids} alt="" />
            </a>
            <p>
              Лаборатория Касперского является участником Альянса по защите
              детей в цифровой среде
            </p>
          </div>
          <div className="container d-flex align-items-center justify-content-between">
            <div className="footer__logo-box d-flex">
              <a
                href="https://www.kaspersky.ru/"
                target="_blank"
                className="footer__logo"
              >
                <img src={kasp_logo} />
              </a>
            </div>
            <div className="footer__info">
              <ul>
                <li>
                  ©&nbsp;{new Date().getFullYear()}&nbsp;АО «Лаборатория
                  Касперского»
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.kaspersky.ru/web-privacy-policy"
                  >
                    Политика конфиденциальности
                  </a>
                </li>
                <li>
                  <a target="_blank" href="https://www.kaspersky.ru/legal">
                    Юридическая информация
                  </a>
                </li>
              </ul>
            </div>
            <div className="social d-flex align-items-center">
              {/* <a href="https://www.facebook.com/KasperskyLabRussia" target="_blank">
                                <svg
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M20.4 12.0001C20.4 7.3609 16.6392 3.6001 12 3.6001C7.36078 3.6001 3.59998 7.3609 3.59998 12.0001C3.59998 16.1927 6.67172 19.6679 10.6875 20.2981V14.4282H8.55466V12.0001H10.6875V10.1495C10.6875 8.04422 11.9416 6.88135 13.8603 6.88135C14.779 6.88135 15.7406 7.04541 15.7406 7.04541V9.1126H14.6814C13.638 9.1126 13.3125 9.76015 13.3125 10.4251V12.0001H15.6422L15.2697 14.4282H13.3125V20.2981C17.3282 19.6679 20.4 16.1927 20.4 12.0001Z"
                                        fill="#AEAEAE"
                                    />
                                </svg>
                            </a>
              <a href="https://twitter.com/Kaspersky_ru" target="_blank">
                <svg
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.88193 19.2C15.2234 19.2 18.692 14.1204 18.692 9.71849C18.692 9.57583 18.692 9.43318 18.6815 9.28543C19.3559 8.81295 19.9379 8.22809 20.4 7.55827C19.7707 7.82937 19.1023 8.00632 18.4179 8.08304C19.1391 7.66705 19.6788 7.0114 19.9361 6.23871C19.2596 6.62651 18.5199 6.90044 17.7485 7.04879C17.2284 6.51496 16.5409 6.16165 15.7922 6.04355C15.0435 5.92545 14.2754 6.04913 13.6068 6.39545C12.9381 6.74178 12.4062 7.29144 12.0934 7.95938C11.7805 8.62732 11.7041 9.3763 11.8761 10.0904C10.5055 10.0242 9.16455 9.6802 7.94037 9.08071C6.7162 8.48123 5.63612 7.63966 4.77023 6.61063C4.32894 7.3438 4.19341 8.21198 4.39125 9.03835C4.58909 9.86472 5.10541 10.5871 5.83506 11.0584C5.28595 11.0433 4.74879 10.9 4.26945 10.6407V10.6814C4.27062 11.4507 4.54673 12.1959 5.05103 12.791C5.55534 13.3861 6.25688 13.7945 7.03694 13.9472C6.52979 14.0803 5.99786 14.0995 5.48187 14.0033C5.70244 14.6651 6.13142 15.2438 6.70888 15.6585C7.28633 16.0732 7.98341 16.3032 8.70271 16.3163C7.48183 17.243 5.97466 17.7471 4.42232 17.748C4.14752 17.7479 3.87295 17.7326 3.59998 17.7021C5.17528 18.6813 7.00899 19.2013 8.88193 19.2Z"
                    fill="#AEAEAE"
                  />
                </svg>
              </a>
              <a
                href="https://www.youtube.com/user/KasperskyChannelRU"
                target="_blank"
              >
                <svg
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.8222 8.58854C20.8222 8.58854 20.6461 7.41015 20.1069 6.89558C19.4224 6.21604 18.6554 6.2129 18.304 6.17283C15.7849 6 12.0071 6 12.0071 6H11.9962C11.9962 6 8.21846 6 5.69937 6.17283C5.34714 6.21211 4.58089 6.21525 3.89562 6.89558C3.35641 7.41329 3.18029 8.58854 3.18029 8.58854C3.06815 9.50534 3.00797 10.4271 3 11.3499V12.6446C3.00794 13.5674 3.06812 14.4892 3.18029 15.406C3.18029 15.406 3.35558 16.5844 3.89562 17.0989C4.58089 17.7785 5.48152 17.7573 5.8805 17.828C7.32033 17.9591 12.0004 18 12.0004 18C12.0004 18 15.7824 17.9945 18.3015 17.8217C18.6529 17.7816 19.4199 17.7785 20.1044 17.0989C20.6436 16.5812 20.8197 15.406 20.8197 15.406C20.9319 14.4892 20.9921 13.5674 21 12.6446V11.3499C20.9929 10.4271 20.9335 9.50538 20.8222 8.58854ZM10.1441 14.2134V9.42128L15.007 11.826L10.1441 14.2134Z"
                    fill="#AEAEAE"
                  />
                </svg>
              </a> */}
              <a
                href="https://dzen.ru/kaspersky_ru"
                target="_blank"
              >
                <svg
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path fill="#AEAEAE" d="M12.037 3c3.56 0 5.65.36 7.118 1.787C20.654 6.315 21 8.39 21 11.95v.1c0 3.56-.346 5.65-1.845 7.163C17.685 20.64 15.61 21 12.035 21h-.07c-3.574 0-5.664-.36-7.12-1.787C3.346 17.685 3 15.61 3 12.05v-.1c0-3.56.346-5.65 1.845-7.163C6.315 3.36 8.39 3 11.965 3h.072Zm-.181 2.142a.13.13 0 0 0-.128.125c-.093 2.464-.406 3.964-1.456 5.013-1.049 1.049-2.545 1.362-5.005 1.455a.13.13 0 0 0-.124.129v.286a.13.13 0 0 0 .124.13c2.46.092 3.957.406 5.005 1.454 1.047 1.047 1.36 2.541 1.455 4.997a.129.129 0 0 0 .128.124h.288a.13.13 0 0 0 .13-.124c.094-2.456.406-3.95 1.454-4.998s2.544-1.36 5.005-1.454a.13.13 0 0 0 .124-.129v-.286a.13.13 0 0 0-.123-.13c-2.46-.092-3.958-.406-5.006-1.454-1.05-1.05-1.362-2.548-1.455-5.013a.13.13 0 0 0-.129-.125h-.287Z" />
                </svg>
              </a>
              <a
                href="https://rutube.ru/channel/27277458/"
                target="_blank"
              >
                <svg
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path fill="#AEAEAE" d="M16.287 5.698H2.75v14.605h3.768V15.55h7.22l3.293 4.752h4.219l-3.632-4.774c1.128-.175 1.94-.59 2.436-1.248.497-.657.745-1.708.745-3.11v-1.094c0-.832-.09-1.489-.248-1.993a3.31 3.31 0 0 0-.813-1.335 3.697 3.697 0 0 0-1.398-.81c-.542-.154-1.219-.241-2.053-.241Zm-.61 6.634h-9.16V8.916h9.16c.52 0 .88.088 1.06.241.181.154.294.438.294.854v1.227c0 .437-.113.722-.293.875-.18.154-.541.22-1.06.22ZM20.491 5.447a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"/>
                </svg>
              </a>
              <a href="https://vk.com/kaspersky" target="_blank">
                <svg
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22.7677 6.86544C22.9448 7.3445 22.3937 8.41782 21.0952 10.0852C20.9181 10.3345 20.6621 10.641 20.3671 11.0243C19.7767 11.7526 19.4422 12.2318 19.3437 12.4617C19.206 12.7492 19.2651 13.0559 19.5013 13.3434C19.6389 13.4967 19.9341 13.8033 20.4064 14.2441H20.4266L20.4659 14.2833C21.5284 15.2416 22.2369 16.0465 22.6107 16.6972L22.6895 16.8507C22.7259 16.9437 22.7523 17.04 22.7683 17.1382C22.7884 17.2723 22.7884 17.4065 22.7683 17.5023C22.7481 17.6173 22.6502 17.7131 22.4926 17.809C22.3351 17.905 22.1188 17.9431 21.8236 17.9431L18.9505 17.9823C18.7734 18.0216 18.557 18.0019 18.3208 17.9248C18.0656 17.8674 17.8688 17.7908 17.7306 17.695L17.4944 17.5608C17.2064 17.3529 16.9424 17.1151 16.7072 16.8517C16.4122 16.5449 16.1562 16.2574 15.9398 16.0078C15.7234 15.7582 15.507 15.5474 15.2505 15.3749C15.0143 15.2024 14.7979 15.1449 14.6208 15.2024L14.542 15.2416L14.3453 15.3949C14.2468 15.4907 14.1682 15.5864 14.1091 15.7207C14.0303 15.8549 13.9713 16.0465 13.9123 16.2957C13.8532 16.5449 13.8337 16.8323 13.8337 17.1396C13.8314 17.2425 13.8182 17.3449 13.7942 17.4452C13.774 17.5409 13.7351 17.5984 13.7156 17.6559L13.6753 17.6952C13.5376 17.8292 13.3212 17.925 13.0653 17.9442H11.787C11.2558 17.9635 10.705 17.906 10.1346 17.7717C9.56252 17.6173 9.07144 17.4255 8.65815 17.1765C8.24486 16.9465 7.85212 16.7165 7.49707 16.4674C7.16256 16.2182 6.8871 16.0074 6.70998 15.8349L6.43452 15.5666L6.11956 15.2408C5.98193 15.0874 5.72602 14.7616 5.31353 14.2441C4.90105 13.7265 4.5075 13.1709 4.11295 12.5955C3.73916 12.0014 3.26662 11.2347 2.73565 10.2766C2.20468 9.31844 1.73134 8.32205 1.27875 7.30623C1.22011 7.17199 1.19996 7.07622 1.19996 6.99949C1.1995 6.93997 1.2133 6.88117 1.24026 6.82776L1.28057 6.77046C1.39865 6.63622 1.61507 6.55948 1.93002 6.55948L5.01953 6.53986L5.27525 6.59736L5.45237 6.69313L5.51141 6.7314C5.6295 6.80814 5.70829 6.92314 5.76733 7.07642C5.9247 7.44047 6.10183 7.82395 6.2985 8.20724L6.75109 9.10805L6.92821 9.4146C7.14483 9.85539 7.36125 10.2389 7.55792 10.5645C7.77454 10.8904 7.95146 11.1395 8.10904 11.312C8.26662 11.4845 8.4238 11.6378 8.58117 11.7336C8.71901 11.8295 8.85684 11.887 8.95517 11.887C9.06279 11.8865 9.16943 11.867 9.26993 11.8295C9.29008 11.8295 9.29008 11.8099 9.31023 11.772C9.33038 11.7524 9.38882 11.6762 9.44786 11.542C9.5192 11.3756 9.57118 11.202 9.60282 11.0243C9.65397 10.7326 9.68681 10.4382 9.70115 10.1427C9.74038 9.75949 9.74038 9.29953 9.70115 8.76284C9.681 8.47533 9.66186 8.20704 9.60282 7.95819C9.54377 7.72818 9.50428 7.55567 9.44524 7.4599L9.3862 7.32586C9.20907 7.07661 8.87457 6.92334 8.42198 6.86584C8.32365 6.84621 8.3434 6.77006 8.48103 6.59756C8.61886 6.46332 8.75649 6.34831 8.91406 6.27158C9.30761 6.07964 10.193 5.98387 11.5903 6.00349C12.2002 6.02312 12.7119 6.06041 13.1252 6.15637C13.2575 6.17746 13.3844 6.22296 13.4992 6.29042C13.5975 6.34792 13.6565 6.44369 13.7156 6.5587C13.7727 6.66727 13.8128 6.78357 13.8345 6.90371C13.8604 7.06861 13.8736 7.23518 13.8738 7.40201V8.0153L13.8345 8.78188V9.68269C13.8345 9.75942 13.8345 9.9127 13.8143 10.1427C13.7942 10.3727 13.7942 10.5452 13.8143 10.6793C13.8143 10.7943 13.8345 10.9477 13.8536 11.1201C13.8728 11.2924 13.9127 11.4268 13.9717 11.5418C14.0301 11.6524 14.1186 11.7452 14.2276 11.8101L14.4243 11.8484C14.4833 11.8676 14.5817 11.8293 14.7195 11.7334C14.8675 11.6165 15.0057 11.4883 15.1328 11.3501C15.2902 11.1968 15.487 10.9477 15.7232 10.6218C15.9594 10.2958 16.2151 9.89347 16.4905 9.45268C16.9431 8.6861 17.3369 7.86301 17.6909 6.97986C17.7106 6.90646 17.7515 6.84007 17.8086 6.78851C17.8481 6.73094 17.8875 6.69261 17.9267 6.67351L17.9654 6.63543L18.0244 6.61581L18.182 6.57754C18.2803 6.55791 18.3394 6.55791 18.3984 6.57754L21.6453 6.55791C21.9405 6.51964 22.1767 6.51964 22.3538 6.57754C22.5505 6.63504 22.6685 6.69254 22.708 6.76928L22.7671 6.86505L22.7677 6.86544Z"
                    fill="#AEAEAE"
                  />
                </svg>
              </a>
              <a href="https://ok.ru/kaspersky" target="_blank">
                <svg
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.0551 15.9238C9.56661 15.7686 8.22456 15.402 7.07554 14.5033C6.93297 14.3915 6.78578 14.2837 6.65567 14.1589C6.15275 13.6759 6.10208 13.1227 6.50003 12.5526C6.84047 12.0647 7.41196 11.9342 8.00597 12.2144C8.121 12.2686 8.23059 12.3364 8.33556 12.4092C10.4769 13.8806 13.4186 13.9212 15.5681 12.4754C15.781 12.3121 16.0086 12.179 16.2725 12.111C16.7854 11.9793 17.2638 12.1677 17.5391 12.6165C17.8536 13.1291 17.8496 13.6294 17.4621 14.0274C16.8677 14.6375 16.1528 15.0788 15.3585 15.3869C14.6075 15.6781 13.7848 15.8247 12.9706 15.922C13.0935 16.0557 13.1514 16.1215 13.2282 16.1987C14.3338 17.3095 15.4442 18.4157 16.5462 19.5299C16.9216 19.9095 17 20.3803 16.7933 20.8219C16.5673 21.3045 16.0613 21.622 15.5652 21.588C15.2509 21.5663 15.0058 21.4099 14.788 21.1905C13.9537 20.3509 13.1037 19.5269 12.2863 18.6715C12.0484 18.4227 11.934 18.4698 11.7241 18.6857C10.8847 19.5498 10.0317 20.4006 9.17369 21.2466C8.78841 21.6264 8.32993 21.6948 7.88311 21.4778C7.40814 21.2476 7.10591 20.7628 7.12923 20.2755C7.14532 19.9459 7.3074 19.6942 7.53362 19.4684C8.62774 18.3759 9.71884 17.2805 10.8103 16.1862C10.8825 16.1134 10.9499 16.0362 11.0551 15.9238Z"
                    fill="#AEAEAE"
                  />
                  <path
                    d="M11.9616 12.1183C9.30626 12.1092 7.12889 9.90791 7.14437 7.24833C7.15965 4.5594 9.33843 2.39248 12.0199 2.39992C14.7068 2.40716 16.8635 4.60524 16.85 7.32213C16.8364 9.97628 14.6439 12.1275 11.9616 12.1183ZM14.3749 7.25477C14.3702 5.93423 13.3185 4.88295 12.0006 4.88174C10.6716 4.88033 9.6105 5.95072 9.62076 7.28332C9.63061 8.59883 10.6913 9.64268 12.0129 9.63785C13.3304 9.63323 14.3793 8.57511 14.3749 7.25477Z"
                    fill="#AEAEAE"
                  />
                </svg>
              </a>
              {/* <a href="https://www.instagram.com/kasperskylabrus/" target="_blank">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.3333 20H8.66667C7.42948 19.9984 6.24332 19.5062 5.36849 18.6314C4.49366 17.7566 4.00159 16.5705 4 15.3333V8.66667C4.00141 7.42942 4.49363 6.24326 5.36849 5.36839C6.24335 4.49353 7.42942 4.00141 8.66667 4L15.3333 4C16.5706 4.00124 17.7569 4.4933 18.6318 5.3682C19.5067 6.2431 19.9988 7.42937 20 8.66667V15.3333C19.9986 16.5706 19.5064 17.7567 18.6315 18.6316C17.7566 19.5065 16.5706 19.9986 15.3333 20ZM12 8.66667C11.1163 8.66773 10.2691 9.01925 9.64421 9.64415C9.01931 10.269 8.66773 11.1163 8.66667 12C8.66773 12.8837 9.01931 13.731 9.64421 14.3559C10.2691 14.9807 11.1163 15.3323 12 15.3333C12.8837 15.3323 13.7309 14.9807 14.3558 14.3559C14.9807 13.731 15.3323 12.8837 15.3333 12C15.3323 11.1163 14.9807 10.269 14.3558 9.64415C13.7309 9.01925 12.8837 8.66773 12 8.66667ZM16.3333 6.66667C16.0681 6.66667 15.8138 6.77202 15.6263 6.95956C15.4388 7.1471 15.3333 7.40145 15.3333 7.66667C15.3333 7.93188 15.4388 8.18624 15.6263 8.37377C15.8138 8.56131 16.0681 8.66667 16.3333 8.66667C16.5985 8.66667 16.8528 8.56131 17.0404 8.37377C17.2279 8.18624 17.3333 7.93188 17.3333 7.66667C17.3333 7.40145 17.2279 7.1471 17.0404 6.95956C16.8528 6.77202 16.5985 6.66667 16.3333 6.66667Z" fill="#AEAEAE"/>
                                </svg>
                            </a> */}
              <a href="https://t.me/kasperskylab_ru" target="_blank">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17ZM8.03869 13.8888L8.18343 11.6902L11.9121 8.07436C12.0744 7.91923 11.8771 7.83339 11.6602 7.98853L7.05064 11.1035L5.06617 10.4369C4.63449 10.2923 4.62647 9.97341 5.15622 9.75134L12.9184 6.5419C13.2779 6.39739 13.5922 6.62773 13.4751 7.21678L13.4748 7.21718L12.1542 13.8999C12.0547 14.3716 11.7947 14.4885 11.4257 14.2664L9.41393 12.6753L8.44302 13.6774C8.33546 13.7928 8.24577 13.8888 8.03869 13.8888Z"
                    fill="#AEAEAE"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
